module.exports = __webpack_public_path__ + "assets/img/8.b469f5ad.jpg";